import { RefObject, useEffect, useState } from 'react';

const INITIAL_HEIGHT = '60vh';

export const useDynamicBackgroundHeight = (
  contentRef: RefObject<HTMLElement>,
  additionalHeightInPx: number = 0
): string => {
  const [backgroundHeight, setBackgroundHeight] =
    useState<string>(INITIAL_HEIGHT);

  const updateBackgroundHeight = () => {
    const topMatterHeight = document.getElementById(
      'base-top-matter-container'
    );

    if (contentRef.current && topMatterHeight) {
      const contentHeight = contentRef.current.offsetHeight;
      const totalHeight =
        topMatterHeight.offsetHeight + contentHeight + additionalHeightInPx;

      setBackgroundHeight(`${totalHeight}px`);
    }
  };

  useEffect(() => {
    updateBackgroundHeight();
    window.addEventListener('resize', updateBackgroundHeight);

    return () => window.removeEventListener('resize', updateBackgroundHeight);
  }, [contentRef]);

  return backgroundHeight;
};
